// DEPENDENCIES

import {
	copdateApi
} from "../configs/core";

import historyHelper from "../helpers/history";
import routerHelper from "../helpers/router";
import storeHelper from "../helpers/store";
import utilsHelper from "../helpers/utils";

import i18n from "../i18n";

// METHODS

/**
 * getAccessToken - ...
 */
const getAccessToken = () => {
	const store = storeHelper.getState();

	return store.LOCAL.user.accessToken;
};

/**
 * getAccessRefreshToken - ...
 */
const getAccessRefreshToken = () => {
	const store = storeHelper.getState();

	return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2OTcyMDY5MTYsImV4cCI6MTY5OTc5ODkxNn0.NuRjKWRSmnL2W2iLxXOk2YwGnEpJSq74Hwlz3iuRH0w";
	//return store.LOCAL.user.accessRefreshToken;
};

/**
 * getApiKey - ...
 */
const getApiKey = () => {
	return copdateApi.key;
};

/**
 * getApiUrl - ...
 */
const getApiUrl = () => {
	return copdateApi.url;
};

/**
 * parseCatchError - Parse catch error.
 * 
 * @param {object} rawError Error object to parse
 */
const parseCatchError = (rawError) => {
	rawError = 
		rawError ||
		{}
	;

	let captureException = false;
	let error = {};
	let notificationProps = {
		autoDismiss: true,
		title: i18n.t("notifications.title.error"),
		type: "danger"
	};
	let response = 
		rawError.response || 
		{}
	;

	if(!utilsHelper.isObjectEmpty(response.data)) {
		error = response.data;

		switch(error.code) {
			case 102: // Invalid access token
			case 103: // Invalid device id
				/*
				storeHelper.dispatch("RESET_ALL");

				historyHelper.navigate(
					{
						pathname: routerHelper.getUrl("signIn")
					}, {
						replace: true
					}
				);

				const {
			pathname,
			search
		} = location;
	
		navigate({
			pathname: routerHelper.getUrl("signIn"),
			search: `?redirect=${encodeURIComponent(pathname + search)}`
		});
				*/
				notificationProps.text = i18n.t("notifications.error.invalidAccessToken");
			break;
			//case 108: // invalid event id
			case 109: // Invalid email
			case 110: // Email already exist
			case 111: // Invalid password
			case 112: // Invalid current password
			case 113: // Invalid first name
			case 114: // Invalid last name
			case 119: // email not found in system
			case 122: // Invalid phone number
			case 126: // Invalid phone country code
				notificationProps.text = i18n.t("notifications.error.invalidData");
			break;
			//case 116: // Unavailable selected size/invalid size
			//case 117: // soldout
			case 118: // Invalid credentials
				notificationProps.text = i18n.t("notifications.error.invalidCredentials");
			break;
			//case 120: // invalid footwear size
			//case 124: // selected size not available but other available
			case 134: // invalid message id
				//...
			break;
			//case 136: // on waiting list for a reservation
			//case 137: // invalid apparel size
			//case 139: // invalid timeslot
			//case 140: // device already use for this event
			case 146: // Inactive account
				notificationProps.text = i18n.t("notifications.error.accountIsInactive");
			break;
			case 148: // email already activated
				notificationProps.text = i18n.t("notifications.error.accountIsAlreadyActive");
			break;
			case 149: // Blocked account
				notificationProps.text = i18n.t("notifications.error.accountIsBlocked");
			break;
			case 202: // version error
				//...dialogs.updateApp
			break;
			case 299: // Maintenance
				//...dialogs.backdoor
			break;
			// 100: // Invalid service name
			// 101: // Invalid SIG
			// 130: // Invalid stripe token
			// 132: // Invalid type
			// 133: // Invalid last4
			default:
				notificationProps.text = i18n.t(
					"notifications.error.unexpectedErrorWithCode",
					{
						code: error.code
					}
				);
			break;
		}
	}

	if(!utilsHelper.isObjectEmpty(notificationProps)) {
		storeHelper.dispatch( 
			"SET_APP_NOTIFICATION", 
			notificationProps
		);
	}

	return error;
};

// EXPORT

export default {
	getAccessToken,
	getAccessRefreshToken,
	getApiKey,
	getApiUrl,
	parseCatchError
};
